import createModel, { prop } from './lib/create_model';

const FavoriteAnswer = createModel({
  modelName: 'FavoriteAnswer',
  properties: {
    id: prop(String).isRequired,
    agentId: prop(String).isRequired,
    answerId: prop(String).isRequired,
    favoritedAt: prop(String).isRequired,
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default FavoriteAnswer;
